import { SxProps, Theme } from '@mui/material';

const container: SxProps<Theme> = {
  height: '100%',
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: 'background.paper',
  px: '20px',
  overflowY: 'auto'
};

const fixedHeader: SxProps<Theme> = {
  backgroundColor: 'white',
  position: 'sticky',
  top: '0px',
  pt: '20px',
  left: '20px',
  right: '20px',
  zIndex: 1000,
  display: 'flex',
  flexDirection: 'column',
  gap: '20px'
};

const topRow: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%'
};

const backButton: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  cursor: 'pointer',
  color: 'primary.main'
};

const backButtonText: SxProps<Theme> = {
  fontFamily: 'Instrument Sans, sans-serif',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: '24px',
  color: 'primary.main'
};

const header: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  width: '100%'
};

const title: SxProps<Theme> = {
  fontFamily: 'Instrument Sans, sans-serif',
  fontSize: '30px',
  fontWeight: 400,
  lineHeight: '38px',
  color: 'text.primary',
  margin: 0
};

const listContainer: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: '30px'
};

const listItem: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  cursor: 'pointer',
  gap: '20px'
};

const listItemText: SxProps<Theme> = {
  fontFamily: 'Instrument Sans, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '26px',
  color: 'primary.main',
  textDecoration: 'underline',
  flex: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  display: '-webkit-box',
  WebkitLineClamp: 3,
  WebkitBoxOrient: 'vertical',
  margin: 0
};

const menuButton: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'start',
  justifyContent: 'center',
  p: 0
};

const loadingContainer: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  textAlign: 'center'
};

const searchInput: SxProps<Theme> = {
  '& .MuiOutlinedInput-root': {
    fontFamily: 'Instrument Sans, sans-serif',
    fontSize: '14px',
    lineHeight: '20px'
  },
  mb: '30px'
};

const sectionHeader: SxProps<Theme> = {
  fontFamily: 'Instrument Sans, sans-serif',
  fontSize: '20px',
  fontWeight: 400,
  lineHeight: '28px',
  color: 'text.primary',
  margin: 0
};

const section: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  width: '100%'
};

const sectionList: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px'
};

export const searchCandidateProfileQueryHistoryListSx = {
  container,
  fixedHeader,
  topRow,
  backButton,
  backButtonText,
  header,
  title,
  listContainer,
  listItem,
  listItemText,
  menuButton,
  loadingContainer,
  searchInput,
  sectionHeader,
  section,
  sectionList
};
